export const CREATE_ROLE = 'CREATE_ROLE';
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAIL = 'CREATE_ROLE_FAIL';

export const GET_ROLE_DETAILS = 'GET_ROLE_DETAILS';
export const GET_ROLE_DETAILS_SUCCESS = 'GET_ROLE_DETAILS_SUCCESS';

export const EDIT_ROLE = 'EDIT_ROLE';
export const EDIT_ROLE_SUCCESS = 'EDIT_ROLE_SUCCESS';
export const GET_ROLES = 'GET_ROLES';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const DELETE_ROLE = 'DELETE_ROLE';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';

export const ADD_PERMISSIONS = 'ADD_PERMISSIONS'
export const ADD_PERMISSIONS_SUCCESS = 'ADD_PERMISSIONS_SUCCESS'
export const REMOVE_PERMISSIONS = 'REMOVE_PERMISSIONS'
export const REMOVE_PERMISSIONS_SUCCESS = 'REMOVE_PERMISSIONS_SUCCESS'